<template>
  <el-affix :offset="10" position="top">
    <top-nav :logo="logoUrl" />
  </el-affix>
  <router-view />
  <bottom-claim :logo="logoUrl" />
</template>

<script>
import TopNav from '@/components/TopNav'
import BottomClaim from '@/components/BottomClaim'
export default {
  components: { TopNav, BottomClaim },
  data() {
    return {
      logoUrl: require('@/assets/logo.png'),
    }
  },
  created() {
    document.documentElement.style.setProperty('--width', window.innerWidth + 'px');
    document.documentElement.style.setProperty('--height', window.innerHeight + 'px');
  },
}
</script>

<style lang="scss">
@import '@/assets/variables.scss';
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  font-weight: 500;
  font-size: 1em;
  color: $neutral-600;
  overflow-x: hidden;
}
:root {
  --width: 0;
  --height: 0;
  --themeColor: #{$brand-primary};
  --themeFontColor: #{$neutral-600};
}

h1 { color: $neutral-800; }
h2 { color: $neutral-700; }

::selection {
  background: rgba($brand-primary, 0.15);
  color: $neutral-900;
}
</style>
